import { getImageAttributes } from '@notino/react-web-utils';

import { getProductView_productDetailByMasterId_variants_imagesByCategory_mainImage } from '@containers/ProductDetailContainer/queries/__generated__/getProductView';

export const getImagesAttributes = (
  images: getProductView_productDetailByMasterId_variants_imagesByCategory_mainImage[],
  domain: string,
  sourceKey: string
) => images.map((image) => getImageAttributes(image, domain, sourceKey));
